module.exports = __webpack_public_path__ + "media/images/v2/t-thumb2-bf95d1bf4444732806b29366b663899e.png";